module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_volanteer.jpg.bak-ad31c200b4d33f7b75c386bcd0b566b6.jpg";